import { Provider } from 'react-redux';
import { store } from '../state';
import Shell from './Shell';
import { BrowserRouter as Router } from 'react-router-dom';
import './base-styles/index.css';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

const APP_ID = process.env.REACT_APP_RUM_APP_ID ?? '';
const COGNITO_POOL_ID = process.env.REACT_APP_RUM_COGNITO_POOL_ID ?? '';
const GUEST_ROLE = process.env.REACT_APP_RUM_GUEST_ROLE ?? '';

let awsRum = null;
try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    guestRoleArn: GUEST_ROLE,
    identityPoolId: COGNITO_POOL_ID,
    endpoint: 'https://dataplane.rum.us-east-2.amazonaws.com',
    telemetries: ['performance', 'errors', 'http'],
    allowCookies: true,
    enableXRay: true,
  };

  const APPLICATION_ID: string = APP_ID;
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'us-east-2';

  awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  console.error('Error initializing CloudWatch RUM web client', error);

  // Ignore errors thrown during CloudWatch RUM web client initialization
}
function App() {
  return (
    <Provider store={store}>
      <Router>
        <Shell />
      </Router>
    </Provider>
  );
}

export default App;
